<template>
  <section class="app-main">
    <router-view :key="key" />
    <!-- <transition name="fade-transform" mode="out-in" >
      <div class="right_main_container">
        <keep-alive :include="/^V2/">
          <router-view :key="key" />
      </keep-alive>
        
      </div>

    </transition> -->
    <!-- <div id="el-main-footer">
      {{config.copyright}}
    </div> -->
  </section>
</template>

<script>
import config from '@/config/config.js'
export default {
  name: 'AppMain',
  computed: {
    key() {
      return this.$route.path
    }
  },
  data(){
    return{
      config:config
    }
  }
}
</script>

<style lang="scss" scoped>
.app-main {
  /* 50= navbar  50  */
  min-height: calc(100vh - 6px);
  width: 100%;
  height: 100%;
   position: relative;
  overflow: auto;
}

.fixed-header+.app-main {
  padding-top: 100px;
}

.hasTagsView {
  .app-main {
    /* 84 = navbar + tags-view = 50 + 34 */
    min-height: calc(100vh - 84px);
  }

  .fixed-header+.app-main {
    padding-top: 84px;
  }
}
#el-main-footer {
  background: none repeat scroll 0 0 white;
  border-top: 1px solid #e7eaec;
  overflow: hidden;
  padding: 5px 6px 0 6px;
  height: 33px;
  font-size: 15px !important;
  color: #7a8b9a;
  text-align: center;
  letter-spacing: 0.8px;
  font-family: Arial, sans-serif !important;
  position: fixed;
  bottom: 0;
  z-index: 99;
  width: 100%;
}
</style>

<style lang="scss">
// fix css style bug in open el-dialog
.el-popup-parent--hidden {
  .fixed-header {
    padding-right: 15px;
  }
}
</style>



<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.icon_fn {
  display: inline-block;
  width: 21px;
  height: 21px;
  margin-right: 5px;
  vertical-align: middle;
}

.icon_video {
  display: inline-block;
  width: 21px;
  height: 21px;
  margin-right: 5px;
  vertical-align: middle;
}

.icon_fn.icon_fn1x1 {
  background-position: 0 0;
}

.icon_fn.icon_fn2x1 {
  background-position: -21px 0;
}

.icon_fn.icon_fn3x1 {
  background-position: -42px 0;
}

.icon_fn.icon_fn4x1 {
  background-position: -63px 0;
}

.icon_nav {
  display: inline-block;
  width: 23px;
  height: 23px;
  vertical-align: middle;
}

.icon_nav.icon_nav1x1 {
  background-position: 0 0;
}

li.is-opened .icon_nav1x1,
.icon_nav.icon_nav1x1:hover {
  background-position: 0 -23px;
}

.icon_nav.icon_nav2x1 {
  background-position: -23px 0;
}

li.is-opened .icon_nav2x1,
.icon_nav.icon_nav2x1:hover {
  background-position: -23px -23px;
}

.icon_nav.icon_nav3x1 {
  background-position: -46px 0;
}

li.is-opened .icon_nav3x1,
.icon_nav.icon_nav3x1:hover {
  background-position: -46px -23px;
}

.icon_nav.icon_nav4x1 {
  background-position: -69px 0;
}

li.is-opened .icon_nav4x1,
.icon_nav.icon_nav4x1:hover {
  background-position: -69px -23px;
}

.icon_nav.icon_nav5x1 {
  background-position: -92px 0;
}

li.is-opened .icon_nav5x1,
.icon_nav.icon_nav5x1:hover {
  background-position: -92px -23px;
}

.icon_nav.icon_nav6x1 {
  background-position: -115px 0;
}

li.is-opened .icon_nav6x1,
.icon_nav.icon_nav6x1:hover {
  background-position: -115px -23px;
}

.icon_nav.icon_nav7x1 {
  background-position: -138px 0;
}

li.is-opened .icon_nav7x1,
.icon_nav.icon_nav7x1:hover {
  background-position: -138px -23px;
}

.icon_nav.icon_nav8x1 {
  background-position: -161px 0;
}

li.is-opened .icon_nav8x1,
.icon_nav.icon_nav8x1:hover {
  background-position: -161px -23px;
}

.icon_nav.icon_nav9x1 {
  background-position: -184px 0;
}

li.is-opened .icon_nav9x1,
.icon_nav.icon_nav9x1:hover {
  background-position: -184px -23px;
}

.icon_nav.icon_nav10x1 {
  background-position: -207px 0;
}

li.is-opened .icon_nav10x1,
.icon_nav.icon_nav10x1:hover {
  background-position: -207px -23px;
}

.icon_nav.icon_nav11x1 {
  background-position: -230px 0;
}

li.is-opened .icon_nav10x1,
.icon_nav.icon_nav11x1:hover {
  background-position: -230px -23px;
}
</style>

<style lang="scss">
aside {
  width: 208px;
  transition: 0.5s;

  &.isCollapse {
    width: 60px;
    overflow: initial;

    .navWrap {
      width: 100%;
      overflow: initial;
    }
  }

  .navWrap {
    position: relative;
    width: 208px;
    height: calc(100% - 40px);
    overflow-y: auto;
    overflow-x: hidden;
  }

  .el-menu {
    height: 100%;
    border-radius: 0px;
    background-color: #fff;
    border-right: 0px;
  }

  .el-menu {
    width: 100%;
  }

  .el-menu--collapse {
    width: 60px;
  }

  .el-submenu {
    //border-bottom:2px solid #f4f4f4;
    background-color: #f4f4f4;

    &.is-active {
      position: relative;
    }

    .el-menu .is-active {
      border: none;
    }
  }

  .el-submenu .el-menu-item {
    min-width: 60px;
    background-color: #fff;
  }

  .el-menu .el-menu-item,
  .el-submenu .el-submenu__title {
    height: 50px;
    line-height: 50px;
    font-size: 14px;
    letter-spacing: 1px;
    background: #ffffff;

    i {
      margin-right: 12px;
    }
  }

  .icon {
    display: inline-block;
    width: 20px;
    height: 20px;
    margin-right: 6px;
  }

  .el-menu .el-menu-item {
    height: 48px;
    line-height: 48px;
  }

  .el-menu .el-menu-item:hover,
  .el-submenu .el-menu-item.is-active {
    background: #f5f5f5;
    color: #5D8C82;
  }


  .el-submenu .el-submenu__title:hover,
  .el-submenu.is-opened > .el-submenu__title {
    background: #fff;
    color: $color;
  }

  // 事项管理
  .icon-matters {
  }

  .el-submenu .el-submenu__title:hover .icon-matters,
  .el-submenu.is-opened .el-submenu__title .icon-matters,
  .el-submenu.is-active .el-submenu__title .icon-matters {
  }

  // 企业管理
  .icon-ent {
  }

  .el-submenu .el-submenu__title:hover .icon-ent,
  .el-submenu.is-opened .el-submenu__title .icon-ent,
  .el-submenu.is-active .el-submenu__title .icon-ent {
  }

  // 隐患管理
  .icon-hidden {
  }

  .el-submenu .el-submenu__title:hover .icon-hidden,
  .el-submenu.is-opened .el-submenu__title .icon-hidden,
  .el-submenu.is-active .el-submenu__title .icon-hidden {
  }

  // 风险管控
  .icon-risk {
  }

  .el-submenu .el-submenu__title:hover .icon-risk,
  .el-submenu.is-opened .el-submenu__title .icon-risk,
  .el-submenu.is-active .el-submenu__title .icon-risk {
  }

  // 第三方管理
  .icon-third {
  }

  .el-submenu .el-submenu__title:hover .icon-third,
  .el-submenu.is-opened .el-submenu__title .icon-third,
  .el-submenu.is-active .el-submenu__title .icon-third {
  }

  // 权限管理
  .icon-permissions {
  }

  .el-submenu .el-submenu__title:hover .icon-permissions,
  .el-submenu.is-opened .el-submenu__title .icon-permissions,
  .el-submenu.is-active .el-submenu__title .icon-permissions {
  }

  .el-submenu .el-submenu__title:hover .fa,
  .el-submenu .el-submenu__title:hover .el-submenu__icon-arrow,
  .el-submenu.is-opened .el-submenu__title .fa,
  .el-submenu.is-opened .el-submenu__title .el-submenu__icon-arrow {
    color: $color;
  }

  .el-menu-item:hover i {
    color: #fff;
  }

  .el-submenu__icon-arrow {
    width: 15px;
    height: 15px;
    line-height: 15px;
    left: 170px !important;
    right: auto !important;

    &::before {
      content: none;
    }
  }

  .is-opened .el-submenu__icon-arrow {
    background-position: right top;
  }

  .navWrap > .el-menu > .el-submenu:not(.is-opened) > .el-submenu__title .el-submenu__icon-arrow {
    transform: rotate(0deg) !important;
  }

  .navWrap > .el-menu > .el-submenu.is-opened > .el-submenu__title .el-submenu__icon-arrow {
    transform: rotate(0deg) !important;
  }

  .el-submenu.is-opened > .el-submenu__title .el-submenu__icon-arrow {
    transform: rotate(0deg) !important;
  }

  .el-submenu:not(.is-opened) > .el-submenu__title .el-submenu__icon-arrow {
    transform: rotate(180deg) !important;
  }
}

#page {
  // width: 100%;
  height: calc(100% - 40px);
  overflow: hidden;

  .tabnavBox {
    border: 0;
    box-shadow: none;
    //margin-bottom:14px;
    height: 50px;
    background: none;

    ul {
      padding-left: 21px;
      padding-right: 21px;
      height: 55px;
    }

    .tabnav {
      height: 40px;
      line-height: 40px;
      border: none;
      padding: 0 15px;
      margin: 0 10px 0 0;
      box-shadow: 0 4px 8px rgba(29, 68, 171, 0.1);
      font-size: 14px;

      border-radius: 0 0 7px 7px;

      &:nth-of-type(1) {
        a {
          white-space: normal;

          width: auto;

          &::before {
            content: '';
            width: 18px;
            height: 18px;
            display: inline-block;
            vertical-align: middle;
            margin-right: 8px;
          }
        }
      }

      .el-icon-error {
        top: 42%;
        right: 0;
        width: 10px;
        height: 10px;
        transform: translate(-100%, -50%);
        vertical-align: midden;

        &::before {
          transition: transform 0.2s linear;
          content: '';
          width: 10px;
          height: 10px;
          display: inline-block;
        }
      }

      .el-icon-error:hover::before {
        transform: rotate(90deg);
      }
    }

    .tabnav:hover,
    .tabnav.active {
      background: #fff;
      font-weight: bold;
      font-size: 16px;
    }

    .tabnav .active a {
      color: #333;
      font-size: 16px;
    }

    .tabnav a {
      color: #333;
      font-size: 14px;
    }
  }

  .el-tabs {
    width: 100%;
    height: 100%;

    .el-tabs__header {
      margin: 0;

      .el-tabs__item {
        color: #000;

        &.is-active {
          color: $color;
        }
      }
    }

    .el-tabs__content {
      height: calc(100% - 40px);

      .el-tab-pane {
        height: 100%;
      }
    }
  }
}
</style>

<style lang="scss" scoped>
.trigger {
  font-size: 22px;
  line-height: 42px;
  padding: 0 18px;
  cursor: pointer;
  color: #ffffff;
  transition: color .3s,background .3s;
}

.trigger:hover {
  background-color: rgb(123, 178, 249);
}
.el-menu--vertical .el-menu--popup {
  .el-menu-item:hover {
    background-color: $color !important;
    color: #fff !important;
  }

  .el-menu-item:hover i {
    color: #fff;
  }
}

/*定义滚动条高宽及背景 高宽分别对应横竖滚动条的尺寸*/
::-webkit-scrollbar {
  width: 9px;
  height: 9px;
}

/*定义滚动条轨道*/
::-webkit-scrollbar-track {
  background-color: transparent;
  -webkit-border-radius: 2em;
  -moz-border-radius: 2em;
  border-radius: 2em;
}

/*定义滑块 内阴影+圆角*/
::-webkit-scrollbar-thumb {
  //background-color:#210192;
  // background-image: -webkit-linear-gradient(45deg,rgba(255,255,255,.4) 25%,transparent 25%,transparent 50%,rgba(255,255,255,.4) 50%,rgba(255,255,255,.4) 75%,transparent 75%,transparent);
  //-webkit-border-radius: 2em;
  //-moz-border-radius: 2em;
  //border-radius: 2em
}

.container {
  position: absolute;
  top: 0px;
  bottom: 0px;
  width: 100%;

  .topbar-wrap {
    height: 68px;
    padding: 0 12px;
    line-height: 68px;
    background: #5D8C82;

    .topbar-logo {
      img {
        width: 40px;
        height: 35px;
      }

      .topbar-title {
        margin: 0 20px 0 10px;
        font-size: 20px;
        // font-weight: bolder;
        color: #fff;
      }
    }

    .topbar-account {
      font-size: 16px;

      .sise {
        color: #fff;
        margin-right: 30px;

        i {
          margin-right: 5px;
          margin-left: 10px;
        }
      }

      .fourfigure {
        color: #fff;
        margin-right: 30px;

        i {
          display: inline-block;
          margin-right: 5px;
        }
      }

      .video {
        color: #fff;
        margin-right: 50px;

        i {
          display: inline-block;
          margin-right: 5px;
        }
      }

      .message {
        display: inline-block;
        width: 30px;
        height: 30px;
        margin-left: 10px;
        background-size: 30px;
      }

      .message2 {
        display: inline-block;
        color: #fff;
        margin-left: 10px;
        cursor: pointer;
      }

      .messages {
        margin-right: 15px;
        color: #fff;

        i {
          font-size: 20px;
          margin-right: 6px;
        }
      }

      .helper {
        margin-right: 20px;
        color: #fff;

        i {
          font-size: 20px;
          margin-right: 6px;
        }
      }
    }

    .userinfo-inner {
      font-size: 14px;
      margin-right: 28px;
      display: inline-block;
      cursor: pointer;
      color: #fff;
      padding-left: 10px;

      i.el-icon-user-solid {
        font-size: 20px;
        margin-right: 6px;
        vertical-align: middle;
      }

      i.el-icon-arrow-down {
        vertical-align: middle;
        font-size: 18px;
        margin-left: 6px;
      }

      .userIcon {
        position: relative;
        top: 10px;
        display: inline-block;
        width: 30px;
        height: 30px;
        background-size: 30px;
      }
    }
  }

  .main {
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    position: absolute;
    top: 68px;
    bottom: 0px;
    overflow: hidden;

    aside {
      min-width: 50px;
      background: #fff;
      position: relative;

      &::-webkit-scrollbar {
        display: none;
      }

      &.showSidebar {
        overflow-x: hidden;
        overflow-y: auto;
      }
    }

    .menu-toggle {
      position: absolute;
      right: -15px;
      top: 50%;
      width: 15px;
      height: 30px;
      text-align: center;
      line-height: 30px;
      cursor: pointer;
      border-radius: 0 5px 5px 0;
      background-color: #fff;
      border: 1px oslid #f00;
      z-index: 100;
      transform: translate(20%, -50%);

      i::before {
        content: '';
        background-color: #f5f5f5;
        display: inline-block;
        line-height: normal;
        width: 8px;
        height: 13px;
      }

      i.fa-rotate-90::before {
        transform: rotate(90deg);
      }
    }
  }

  .content-container {
    position: relative;
    background: #f5f5f5;
    width: calc(100% - 208px);
    box-sizing: border-box;
    transition: 0.5s;

    &.iscop {
      width: calc(100% - 60px);
    }

    #elmain {
      height: calc(100% - 50px);
      padding: 0;

      .bg {
        background: #fff;
        overflow: hidden;
      }
    }

    footer {
      height: 30px;
      margin: 0 21px;
      line-height: 40px;
      text-align: center;
      font-size: 14px;
      color: #00000073;
      font-weight: 500;
      box-sizing: border-box;
    }
  }
}
</style>




// WEBPACK FOOTER //
// src/layout/components/AppMain.vue